import { render } from "./StaffDatatableDoctorActions.vue?vue&type=template&id=621a71f1"
import script from "./StaffDatatableDoctorActions.vue?vue&type=script&lang=js"
export * from "./StaffDatatableDoctorActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__